import {createActions} from "../../../baseClasses/ActionFactory";
import {createTreeActions} from '../../../baseClasses/TreeActionFactory';

const {types: generalTypes, actions: generalActions} = createActions({store: 'EMPLOYEES'});
const {types: treeTypes, actions: treeActions} = createTreeActions({store: 'EMPLOYEES'});
const allActions = {...generalActions, ...treeActions};
const allTypes = {...generalTypes, ...treeTypes};
export {allTypes as types, allActions as actions};
